module.exports = __webpack_public_path__ + "static/img/productPartner_14_1.1de1be3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/productPartner/productPartner_14_1.png
// module id = ZRdK
// module chunks = 34